import {
    CLOSE_MODAL,
    OPEN_MODAL
} from './types/modal-action-types';

export const openModal = ( modalType, attributes ) => {
    return {
        attributes,
        modalType,
        type: OPEN_MODAL,
    };
};

export const closeModal = () => {
    return {
        type: CLOSE_MODAL
    };
};

export const openVerificationBySenderModal = () => {
    return openModal( 'verifiedBySender' );
};

export const openVerificationByDomainModal = () => {
    return openModal( 'verifiedByDomain' );
};

export const openWhoisModal = ( domain ) => {
    return openModal( 'whois', { domain } );
};

const openDomainGroupingModal = ( modalAttributes = {} ) => {
    return openModal( 'domainGrouping', modalAttributes );
};

export const openBaseDomainGroupingModal = () => {
    return openDomainGroupingModal();
};

export const openEditDomainGroupingModal = ( domainGroupId ) => {
    return openDomainGroupingModal( { domainGroupId, editMode: Boolean( domainGroupId ) } );
};

export const openAssignDomainsToGroupModal = ( domains = [] ) => {
    return openDomainGroupingModal( { assignMode: true, domains } );
};

export const addDomainDetailNotesModal = () => {
    return openModal( 'addDomainDetailNotes' );
};
